import React, { useState } from 'react';
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material';
import { useLanguage } from '../i18n/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { LanguageSelector } from './LanguageSelector';
import { MAX_WIDTH } from '../App';

export const SetupScreen: React.FC = () => {
  const { t } = useLanguage();
  const { addHouse, domain: defaultDomain } = useAuth();

  const [clientId, setClientId] = useState('');
  const [domain, setDomain] = useState(defaultDomain);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const errors = {
    clientId: submitted && !clientId.trim(),
    domain: submitted && !domain.trim(),
    username: submitted && !username.trim(),
    password: submitted && !password.trim(),
  };

  const handleSubmit = () => {
    setSubmitted(true);
    if (!clientId.trim() || !domain.trim() || !username.trim() || !password.trim()) return;
    addHouse(clientId.trim(), domain.trim(), username.trim(), password);
  };

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '100dvh',
      pt: 'env(safe-area-inset-top)', px: 3,
    }}>
      <Box sx={{ width: '100%', maxWidth: MAX_WIDTH }}>
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <LanguageSelector />
        </Box>
        <Typography variant="h4" fontWeight="bold" mb={1}>{t.setupTitle}</Typography>
        <Typography variant="body2" color="text.secondary" mb={4}>{t.setupSubtitle}</Typography>

        <TextField
          fullWidth label={t.setupDeviceId} value={clientId}
          onChange={e => setClientId(e.target.value)}
          error={errors.clientId} helperText={errors.clientId ? t.fieldRequired : ''}
          InputProps={{ endAdornment: <InputAdornment position="end">{domain}</InputAdornment> }}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth label={t.setupDomain} value={domain}
          onChange={e => setDomain(e.target.value)}
          error={errors.domain} helperText={errors.domain ? t.fieldRequired : ''}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth label={t.setupUsername} value={username}
          onChange={e => setUsername(e.target.value)}
          error={errors.username} helperText={errors.username ? t.fieldRequired : ''}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth label={t.setupPassword} value={password} type="password"
          onChange={e => setPassword(e.target.value)}
          error={errors.password} helperText={errors.password ? t.fieldRequired : ''}
          sx={{ mb: 3 }}
        />

        <Button fullWidth variant="contained" onClick={handleSubmit}
          sx={{ py: 1.5, fontSize: 16, fontWeight: 'bold', borderRadius: 2 }}
        >
          {t.setupSubmit}
        </Button>
      </Box>
    </Box>
  );
};
